import { adaptedToCompte, compteToAdapted, comptesToAdapted } from "../../adapter/compteAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_COMPTES = "LOAD_COMPTES";
export const LOAD_SUCCESS_COMPTES = "LOAD_SUCCESS_COMPTES";
export const LOAD_FAIL_COMPTES = "LOAD_FAIL_COMPTES";
export const SAVE_SUCCESS_COMPTES = "SAVE_SUCCESS_COMPTES";
export const SAVE_FAIL_COMPTES = "SAVE_FAIL_COMPTES";
export const UPDATE_SUCCESS_COMPTES = "UPDATE_SUCCESS_COMPTES";
export const UPDATE_FAIL_COMPTES = "UPDATE_FAIL_COMPTES";
export const DELETE_SUCCESS_COMPTES = "DELETE_SUCCESS_COMPTES";
export const DELETE_FAIL_COMPTES = "DELETE_FAIL_COMPTES";

export function loadComptes() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`comptes`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.compte);
          dispatch({
            type: LOAD_SUCCESS_COMPTES,
            payload: comptesToAdapted(res.compte),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_COMPTES,
            error: err,
          });
        });
    });
  };
}

export function saveCompte(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`comptes`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToCompte(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.compte);
          dispatch({
            type: SAVE_SUCCESS_COMPTES,
            payload: compteToAdapted(res.compte),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_COMPTES,
            error: err,
          })
        );
    });
  };
}

export function updateCompte(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`comptes/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToCompte(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.compte);
          dispatch({
            type: UPDATE_SUCCESS_COMPTES,
            payload: compteToAdapted(res.compte),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_COMPTES,
            error: err,
          })
        );
    });
  };
}

export function deleteCompte(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`comptes/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.compte);
          dispatch({
            type: DELETE_SUCCESS_COMPTES,
            payload: compteToAdapted(res.compte),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_COMPTES,
            error: err,
          });
        });
    });
  };
}
